/**
 * 예약 상품 상세 정보 - PC
 */
$(function () {
    // ###########################################################
    // A. 변수 설정 영역
    // ###########################################################
    let isLoading = false;  //로딩 여부 (중복 요청 방지)

    const p_no = 373287;
    let gubun = 'R';
    const res_type2 = '';

    let sang;
    let chkin;
    let chkout;
    let night = 1;
    let room_cnt = 1;
    let person;

    let min_person;  //뒷단에서 사용
    let max_person;  //뒷단에서 사용
    let room_name;   //뒷단에서 사용

    let origin_price = 0;  // 원래 가격 (화면 표시 용도)
    let basic_price = 0;  //콘도 기본 사용료 (몇박 & 객실수 & 인원 3개로 경정된 기본 콘도 사용료)
    let final_sum_price = 0;  //전체 합산 금액
    let normal_price = 0;
    let show_price = 0;
    let deposit_price = 0;

    // ###########################################################
    // B. 헬프 함수 영역
    // ###########################################################

    /**
     * ShowPrice 반환
     *
     * 최종금액을 받아서 ShowPrice 계산 및 반환
     */
    function getShowPrice(fanal_price) {
        let price = fanal_price / 1.21;

        price = Math.floor(price / 100) * 100; // 100 단위 절삭

        return price;
    }

    /**
     * 체크인/체크아웃 날짜로 night 반환
     */
    function getNight(checkInDate, checkOutDate) {
        const inDate = new Date(checkInDate);
        const outDate = new Date(checkOutDate);

        // 날짜 차이 계산 (밀리초 -> 일수)
        const diffTime = outDate - inDate;
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

        return diffDays;
    }

    /**
     * 달력에서 체크인, 체크아웃 날짜 확인
     *
     * 달력의 chkin, chkou을 확인해서 리턴
     */
    function confirmDate() {
        const $calendar = $('#cal_pc_detail .calendar');
        const $chkin = $calendar.find('.day.chkin');
        const $chkout = $calendar.find('.day.chkout');

        const startDate = $chkin.attr('data-dt') || '';
        const endDate = $chkout.attr('data-dt') || '';

        return [startDate, endDate];
    }

    /**
     * 초과 인원 포함 여부를 판단해서 base_price를 역산하고,
     * 변경된 투숙 인원 기준으로 금액을 재계산한다.
     *
     * @param {number} old_price 기존 금액 (초과 요금 포함 가능)
     * @param {number} old_person 기존 투숙 인원
     * @param {number} new_person 변경된 투숙 인원
     * @param {number} room_cnt 객실 수
     * @param {number} max_person 객실당 최대 인원
     * @returns {number} 변경된 인원 기준 최종 금액
     */
    function getNewBasePriceByPerson(old_price, old_person, new_person, room_cnt, max_person) {
        const allowed = room_cnt * max_person;

        // 1. 기존 초과 인원 계산
        let old_extra = 0;
        if (old_person > allowed) {
            old_extra = (old_person - allowed) * 30000;
        }

        // 2. base_price 역산
        const base_price = old_price - old_extra;

        // 3. 새 초과 인원 계산
        let new_extra = 0;
        if (new_person > allowed) {
            new_extra = (new_person - allowed) * 30000;
        }

        // 4. 최종 금액 = base_price + 새 초과 요금
        return base_price + new_extra;
    }

    /**
     * 객실 수 변경 시, 초과 인원 포함 여부 고려해 최종 금액 재계산
     *
     * @param {number} old_price 기존 금액 (초과 포함 가능)
     * @param {number} old_room_cnt 기존 객실 수
     * @param {number} new_room_cnt 변경된 객실 수
     * @param {number} person 현재 투숙 인원
     * @param {number} max_person 객실당 최대 인원
     * @returns {number} 최종 계산된 금액
     */
    function getNewBasePriceByRoomCnt(old_price, old_room_cnt, new_room_cnt, person, max_person) {
        const old_allowed = old_room_cnt * max_person;
        const new_allowed = new_room_cnt * max_person;

        // 1. 기존 초과 인원 계산 → 초과 요금 추정
        let old_extra = 0;
        if (person > old_allowed) {
            old_extra = (person - old_allowed) * 30000;
        }

        // 2. base_price 역산 (기존 객실 1개당 가격)
        const base_unit_price = (old_price - old_extra) / old_room_cnt;

        // 3. 새 초과 인원 계산
        let new_extra = 0;
        if (person > new_allowed) {
            new_extra = (person - new_allowed) * 30000;
        }

        // 4. 새 총 가격 = base 단가 × 새 객실 수 + 새 초과 요금
        return Math.round(base_unit_price * new_room_cnt + new_extra);
    }

    /**
     * B. 가격을 분리해서 출력 (단품금액, 봉사료, 세금)
     */
    function refresh_split_price(totalAmount, exec='print') {
        const round = (num) => Math.round(num);

        const final_calc = round(totalAmount / 1.21);                   // 객실단품금액
        const serve_price = round(final_calc * 0.1);                    // 봉사료
        const vat_price = round((final_calc + serve_price) * 0.1);     // 세금
        //const final_price = final_calc + serve_price + vat_price;      // 총합 (검증용)

        if (exec == 'print') {  //화면 출력
            $('#price_base').text(addComma(final_calc));
            $('#price_service').text(addComma(serve_price));
            $('#price_tax').text(addComma(vat_price));
        } else if (exec == 'get') {
            return {
                "price_base": addComma(final_calc),
                "price_service": addComma(serve_price),
                "price_tax": addComma(vat_price)
            }
        }
    }

    /**
     * B. 가격 refrash 및 화면 refrach
     */
    function refresh_about_price_all() {
        const priceSum = basic_price;

        $('#price_sum').text(addComma(priceSum));  //객실설정: 계

        $('#final_no_sale_price').text(addComma(origin_price));
        $('#final_price').text(addComma(basic_price));
    }

    /**
     * B. 몇박몇일 select box Option 반환
     */
    function getNightSelectOptionHtml(night, maxDay) {
        let html = '';
        for (let d = 1; d <= maxDay; d++) {
            let selected = (night == d) ? 'selected=""' : '';
            html += `<option value="${d}" ${selected}>${d}박</option>`;
        }

        return html;
    }

    /**
     * B. 객실개수&인원수 select box Option 반환
     */
    function getCntSelectOptionHtml(cnt, maxCnt) {
        let html = '';
        for (let n = 1; n <= maxCnt; n++) {
            let selected = (cnt == n) ? 'selected=""' : '';
            html += `<option value="${n}" ${selected}>${n}</option>`;
        }

        return html;
    }

    /**
     * B. 금액 콤마 추가
     *
     * @param int amount
     * @reutrn string
     */
    function addComma(amount) {
        return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    /**
     * B. 금액 콤마 제거
     *
     * @param string str
     * @return number
     */
    function delComma(str) {
        return Number(str.replace(/,/g, ''));
    }


    // ###########################################################
    // C. 객실 상세정보(Detail) 출력 관련
    // ###########################################################

    /**
     * C. 리스트 객실(콘도) 클릭 이벤트 처리
     *
     * 객실(콘도) 상세 정보 출력
     */
    $(document).on('click', '.book-product-click', function (){
        const $li = $(this);
        const $radio = $li.find('input[type="radio"]');

        if (!$radio.prop('checked')) {
            $('#book-detail-info').remove();  //기존 상세정보 삭제

            $radio.prop('checked', true); //라디오 선택 처리

            const data = getDataFromHtml($li);  //html(화면)에서 받는 데이터 세팅
            sang = data.sang;  //객실 ID 업데이트

            min_person = data.min_person;  //룸 최소 인원수
            max_person = data.max_person;  //룸 최대 인원수
            person = data.min_person;  //디폴트 최소 인원
            room_name = data.room_name;  //룸 이름
            chkin = data.chkin; //체크인
            chkout = data.chkout;  //체크아웃
            night = data.night;  //몇박
            origin_price = data.normal;  // 원래 가격 (화면 표시 용도)
            basic_price = data.price; //콘도 기본 사용료
            room_cnt = 1;

            loadDetailData($li);  // 상세 정보 ajax 요청
        }
    });

    /**
     * C. 만실된 리스트 객실(콘도) 클릭 이벤트 처리
     */
    $(document).on('click', '.book-product-closed-click', function (e){
        if ($(e.target).is('input, label, label *')) return;

        alert('예약마감된 객실입니다.');

        return;
    });

    /**
     * C. 상세 > 객실 설정 > 체크인/체크아웃 달력 변경 후 처리
     */
    $(document).on('click', '#btn-booking-choice-date-detail', function (){
        var dateArr = confirmDate();
        var chkin_new = dateArr[0];
        var chkout_new = dateArr[1];

        if (!chkout_new) {
            $('input[name="chkin"]').val(chkin);  //원복
            $('input[name="chkout"]').val(chkout); //원복
            alert('체크아웃 날짜가 선택되지 않았습니다.');
            return;
        }

        var night_new = getNight(chkin_new, chkout_new);

        $.ajax({
            url: '/ajax/roomDetail',
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: {p_no: 373287, r_no: sang, chkin: chkin_new, night: night_new, cnt: room_cnt}, // 폼 데이터 직렬화해서 보내기
            dataType: 'json',
            success: function(R) {
                if (R.rsv != 'Y') {  //예약 불가능 할 경우
                    alert(R.msg);
                    $('input[name="chkin"]').val(chkin);  //원복
                    $('input[name="chkout"]').val(chkout); //원복
                    return;
                }

                $('.input-wrap input[name="chkin"]').val(chkin_new);
                $('.input-wrap input[name="chkout"]').val(chkout_new);

                night = night_new;      //x박 업데이트
                basic_price = R.price;  //가격 변경 적용
                origin_price = R.price; //같게 세팅
                chkout = R.chkout;  //체크아웃 업데이트
                chkin = chkin_new;  //체크인 업데이트

                normal_price = R.normal_price;
                show_price = R.show_price;
                deposit_price = R.deposit_price;

                refresh_split_price(basic_price);  // 단품, 봉사료, 세금 금액 새로고침
                refresh_about_price_all(); // 화면 가격 새로고침 (단품, 봉사료, 세금 금액 제외)
                $("#select-night").val(night).prop("selected", true);  //x박 select 박스 변경
            },
            error: function(xhr, status, error) {
                alert('데이터를 불러오는 중입니다.');
            }
        });
    });

    /**
     * C. 상세> 객실 설정 > 몇박Select box 변경 시, 상세 정보 리로딩
     *
     * 몇박여부 변경 시, 모든 정보를 초기화 및 객실정보 New 로딩
     */
    $(document).on('change', '#select-night', function (){
        const night_upd = this.value;

        $.ajax({
            url: '/ajax/roomDetail',
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: {p_no: 373287, r_no: sang, chkin: chkin, night: night_upd, cnt: room_cnt}, // 폼 데이터 직렬화해서 보내기
            dataType: 'json',
            success: function(R) {
                if (R.rsv != 'Y') {  //예약 불가능 할 경우
                    alert(R.msg);
                    $('#select-night').val(night);  //변경사항 복원
                    return;
                }

                night = night_upd;      //x박 업데이트

                basic_price = getNewBasePriceByPerson(R.price, min_person, person, room_cnt, min_person);
                origin_price = basic_price; //같게 세팅
                chkout = R.chkout;
                $('.input-wrap input[name="chkout"]').val(chkout);

                normal_price = R.normal_price;
                show_price = R.show_price;
                deposit_price = R.deposit_price;

                refresh_split_price(basic_price);  // 단품, 봉사료, 세금 금액 새로고침
                refresh_about_price_all(); // 화면 가격 새로고침 (단품, 봉사료, 세금 금액 제외)
            },
            error: function(xhr, status, error) {
                alert('데이터를 불러오는 중입니다.');
            }
        });
    });

    /**
     * C. 객실 상세정보 출력
     *
     * 화면 HTML에서 받는(IN) 데이터는 여기에서 설정
     */
    function getDataFromHtml($This) {
        return {
            'base_ts': $This.data('basets'),
            'night': $This.data('night'),
            'chkin': $This.data('chkin'),
            'chkout': $This.data('chkout'),
            'sang': $This.data('sang'),
            'person': $This.data('person'),
            'min_person': $This.data('min-person'),
            'max_person': $This.data('max-person'),
            'price': $This.data('price'),
            'normal': $This.data('normal'),
            'room_name': $This.data('room-name')
        }
    }

    /**
     * C. 객실 상세정보 출력
     *
     * 객실 상세 정보 HTML 출력
     * 특정 콘도의 맨 처음 객실정보, 패키지선택
     */
    function renderDetailHtml($This) {
        const nightSelectOptionHtml = getNightSelectOptionHtml(night, 15); //몇박몇일 select box Option
        const roomCntSelectOptionHtml = getCntSelectOptionHtml(room_cnt, 15); //객실개수 select box Option
        const personCntSelectOptionHtml = getCntSelectOptionHtml(person, max_person); //인원수 select box Option

        const splitPrice = refresh_split_price(basic_price, 'get');  // 단품, 봉사료, 세금 금액 반환
        const price_base = splitPrice.price_base;
        const price_service = splitPrice.price_service;
        const price_tax = splitPrice.price_tax;

        const detailHtml = `
            <div class="more-wrap" id="book-detail-info" style="display:block;">
                <ul class="option">
                    <li>
                        <h3>1 객실 설정</h3>
                        <h5>${room_name}</h5>
                        <div class="input-wrap">
                            <p>체크인</p>
                            <input name="chkin" value="${chkin}" readonly="" onclick="$('#cal_pc_detail').show()" class="" data-type="none">
                            <select class="prd-night" id="select-night">
                                ${nightSelectOptionHtml}
                            </select>
                        </div>
                        <div class="input-wrap">
                            <p>체크아웃</p>
                            <input name="chkout" value="${chkout}" readonly="" onclick="$('#cal_pc_detail').show()" class="" data-type="none">
                        </div>
                        <div class="input-wrap">
                            <p>객실갯수 </p>
                            <select id="select-room-cnt">
                                ${roomCntSelectOptionHtml}
                            </select>
                            <p>투숙인원</p>
                            <select id="select-person">
                                ${personCntSelectOptionHtml}
                            </select>
                        </div>
                        <ul class="receipt">
                            <li>
                                <p>객실단품금액</p>
                                <p class="txtRed"><span id="price_base">${price_base}</span>원</p>
                            </li>
                            <li>
                                <p>봉사료</p>
                                <p class="txtRed"><span id="price_service">${price_service}</span>원</p>
                            </li>
                            <li>
                                <p>세금</p>
                                <p class="txtRed"><span id="price_tax">${price_tax}</span>원</p>
                            </li>
                            <li>
                                <p>추가옵션 상품금액</p>
                                <p class="txtRed">0원</p>
                            </li>
                            <li> <hr></li>
                            <li>
                                <p>계</p>
                                <p class="txtRed"><span id="price_sum">${addComma(basic_price)}</span>원</p>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <h3>2패키지 선택</h3>
                        <p>구매 가능한 패키지가 없습니다.</p>
                    </li>
                    <li>
                        <h3>3패키지 안내</h3>
                    </li>
                </ul>
                <div class="total">
                    <p>
                        최종 결제금액<span class="sub">(VAT, 봉사료, 예약수수료 포함)</span>
                        <del><span id="final_no_sale_price">${addComma(origin_price)}</span>원</del>
                        <span class="txtRed"><span id="final_price">${addComma(basic_price)}</span>원</span>
                    </p>
                    <a class="btn" id="btn-go-reservation">예약하기 ></a>
                </div>
            </div>
        `;

        $This.append(detailHtml);  // html 화면 삽입


    }

    /**
     * C. 객실 상세정보 출력
     *
     * 객실 상세정보 검색 Ajax 요청 처리
     */
    function loadDetailData($This) {
        if (isLoading) return; // 중복 로딩 방지
        isLoading = true;

        $.ajax({
            url: '/ajax/roomDetail',
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: {p_no: 373287, r_no: sang, chkin: chkin, night: night, cnt: room_cnt}, // 폼 데이터 직렬화해서 보내기
            dataType: 'json',
            success: function(R) {
                // 예약 불가능 할 경우 alert 및 페이지 객실 리스트 리로딩
                if (R.rsv != 'Y') {  //예약 불가능 할 경우
                    alert(R.msg);
                    location.reload();
                    return;
                }

                normal_price = R.normal_price;
                show_price = R.show_price;
                deposit_price = R.deposit_price;

                $('#book-detail-info').remove(); //기존의 객실정보 삭제
                renderDetailHtml($This);  // 화면 출력

                isLoading = false;
            },
            error: function(xhr, status, error) {
                isLoading = false;
                alert('데이터를 불러오는 중입니다.');
                location.reload();
            }
        });
    }

    // ###########################################################
    // F. 객실 갯수 변경 시 처리
    // ###########################################################

    /**
     * F. 상세> 객실 설정 > 객실갯수 Select box 변경 시, 대응 가격 업데이트
     */
    $(document).on('change', '#select-room-cnt', function (){
        const room_cnt_upd = this.value;

        $.ajax({
            url: '/ajax/roomDetail',
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: {p_no: 373287, r_no: sang, chkin: chkin, night: night, cnt: room_cnt_upd}, // 폼 데이터 직렬화해서 보내기
            dataType: 'json',
            success: function(R) {
                if (R.rsv != 'Y') {  //예약 불가능 할 경우
                    alert(R.msg);
                    $('#select-room-cnt').val(room_cnt);  //변경사항 복원
                    return;
                }

                room_cnt = room_cnt_upd;      //객실갯수 업데이트

                basic_price = R.price;
                origin_price = basic_price; //같게 세팅

                normal_price = R.normal_price;
                show_price = R.show_price;
                deposit_price = R.deposit_price;

                person = min_person;

                // 객실갯수 변경 시 대응되는 투숙인원 SelectBox 선택 가능한 갯수도 업데이트
                const maxSelectBoxPerson = max_person * room_cnt; //전체 투숙가능한 인원
                const personSelectOoption = getCntSelectOptionHtml(min_person, maxSelectBoxPerson);
                $('#select-person').empty();
                $('#select-person').append(personSelectOoption);

                //화면 새로고침
                refresh_about_price_all();  //화면 금액 새로고침
                refresh_split_price(basic_price);  //단품금액, 봉사료, 세금 새로고침
            },
            error: function(xhr, status, error) {
                alert('데이터를 불러오는 중입니다.');
            }
        });
    });

    // ###########################################################
    // G. 투숙인원 변경 시 처리
    // ###########################################################

    /**
     * G. 상세> 객실 설정 > 투숙인원 Select box 변경 시, 대응 가격 업데이트
     */
    $(document).on('change', '#select-person', function (){
        // 투숙인원 변경 시, 금액 계
        basic_price = getNewBasePriceByPerson(basic_price, person, this.value, room_cnt, min_person);
        origin_price = basic_price;

        person = this.value;

        refresh_about_price_all();  //화면 금액 새로고침
        refresh_split_price(basic_price);  //단품금액, 봉사료, 세금 새로고침
    });

    // ###########################################################
    // H. 예약하기 시 처리
    // ###########################################################

    /**
     * 예약하기 클릭 이벤트 처리
     */
    $(document).on('click', '#btn-go-reservation', function (){
        //전송 할 폼 데이터 세팅
        const $form = $('<form>', {
            method: 'POST',
            action: '/booking/reservation'  // 전송할 URL
        });

         // CSRF 토큰 추가
        $form.append($('<input>', {
            type: 'hidden',
            name: '_token',
            value: $('meta[name="csrf-token"]').attr('content')
        }));

        // 1. 일반 변수들 추가
        $form.append($('<input>', { type: 'hidden', name: 'fval_s', value: '' }));
        $form.append($('<input>', { type: 'hidden', name: 'p_no', value: p_no }));
        $form.append($('<input>', { type: 'hidden', name: 'gubun', value: 'R' }));
        $form.append($('<input>', { type: 'hidden', name: 'res_type2', value: res_type2 }));
        $form.append($('<input>', { type: 'hidden', name: 'abr_val', value: '' }));
        $form.append($('<input>', { type: 'hidden', name: 'rent_option', value: '' }));
        $form.append($('<input>', { type: 'hidden', name: 'sang', value: sang }));
        $form.append($('<input>', { type: 'hidden', name: 'hseldate', value: chkin }));
        $form.append($('<input>', { type: 'hidden', name: 'nseldate', value: chkout }));
        $form.append($('<input>', { type: 'hidden', name: 'night', value: night }));
        $form.append($('<input>', { type: 'hidden', name: 'room_cnt', value: room_cnt }));
        $form.append($('<input>', { type: 'hidden', name: 'person', value: person }));

        $form.append($('<input>', { type: 'hidden', name: 'min_person', value: min_person }));
        $form.append($('<input>', { type: 'hidden', name: 'max_person', value: max_person }));
        $form.append($('<input>', { type: 'hidden', name: 'room_name', value: room_name }));

        // 2. 합산 값 추가
        const final_price = basic_price;

        $form.append($('<input>', { type: 'hidden', name: 'final_price', value: final_price }));
        $form.append($('<input>', { type: 'hidden', name: 'normal_price', value: normal_price }));
        $form.append($('<input>', { type: 'hidden', name: 'deposit_price', value: deposit_price }));
        $form.append($('<input>', { type: 'hidden', name: 'show_price', value: show_price }));

        //refer 추가 (모바일 할인여부)
        const refer = $('#refer_val').val();
        const event_chk = (refer === 'k') ? 'Y' : '';
        const event_sub = (refer === 'k') ? 'Y' : '';
        $form.append($('<input>', { type: 'hidden', name: 'refer', value: refer }));
        $form.append($('<input>', { type: 'hidden', name: 'event_chk', value: event_chk }));
        $form.append($('<input>', { type: 'hidden', name: 'event_sub', value: event_sub }));

        // 3. from npay 추가 (네이버페이 쿠폰 진입여부)
        const from_npay_val = $('#from_npay_val').val();
        $form.append($('<input>', { type: 'hidden', name: 'from_npay', value: from_npay_val }));

        $form.appendTo('body').submit();
    });

});
